<script>
export default {
  name: 'IconMenu',
  functional: true,
  // eslint-disable-next-line
  render: h => (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>icon/menu</title>
      <desc>Created with Sketch.</desc>
      <g id="icon/menu" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path
          d="M23.8333333,20.6666667 C24.7538079,20.6666667 25.5,21.4128588 25.5,22.3333333 C25.5,23.2538079 24.7538079,24 23.8333333,24 L6.16666667,24 C5.24619208,24 4.5,23.2538079 4.5,22.3333333 C4.5,21.4128588 5.24619208,20.6666667 6.16666667,20.6666667 L23.8333333,20.6666667 Z M23.8333333,13.3333333 C24.7538079,13.3333333 25.5,14.0795254 25.5,15 C25.5,15.9204746 24.7538079,16.6666667 23.8333333,16.6666667 L6.16666667,16.6666667 C5.24619208,16.6666667 4.5,15.9204746 4.5,15 C4.5,14.0795254 5.24619208,13.3333333 6.16666667,13.3333333 L23.8333333,13.3333333 Z M23.8333333,6 C24.7538079,6 25.5,6.74619208 25.5,7.66666667 C25.5,8.58714125 24.7538079,9.33333333 23.8333333,9.33333333 L6.16666667,9.33333333 C5.24619208,9.33333333 4.5,8.58714125 4.5,7.66666667 C4.5,6.74619208 5.24619208,6 6.16666667,6 L23.8333333,6 Z"
          id="Combined-Shape"
          fill="#333732"
        />
      </g>
    </svg>
  ),
};
</script>
